import { createPostFetch } from '../../../lib/createFetch';
import {
    AskQuestionReq,
    AskQuestionRes,
} from '../../../pages/api/faq/sendQuestion';

export const registrationHelpApi = createPostFetch<
    AskQuestionReq,
    AskQuestionRes
>('/api/faq/sendQuestion');
